<body>
    

    <div class="main-wrapper">
    <div class="main-content">
            <header>
           
                    <div class="head-line">
                 
                        <p>Email configuration</p>
                    </div>
                <div class="user-wrapper">
                   <p>Skillplex Technologies</p>
                  
                    <div>
                        <img class="log1" src="../../assets/images/Ellipse 2.png">
                    </div>
                </div>
            </header>
            
            <main class="main-2">

               <div class="container">
                <div class="projects">
                    
                    
                    <div class="two-screen">
<!---sec sidebar-->

<div class="main-side">
    <form class="staff-form"  [formGroup]="settingsForm">
        <div class="row">
            <div class="col-lg-6 col-xs-12 col-sm-6">
        <div class="form-group">
          <label>Form*</label>
          <input type="text" class="form-control" placeholder="Type here"   formControlName="form">
        </div>
        </div>
        <div class="col-lg-6 col-xs-12 col-sm-6">
            <div class="form-group">
              <label>Host*</label>
              <input type="text" class="form-control" placeholder="Type here" formControlName="host">
            </div>
            </div>
            <div class="col-lg-6 col-xs-12 col-sm-6">
                <div class="form-group">
                  <label>Port*</label>
                  <input type="text" class="form-control" placeholder="Type here" formControlName="port">
                </div>
                </div>
   
                <div class="col-lg-6 col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Email username*</label>
                      <input type="email" class="form-control" placeholder="Type here" formControlName="userName">
                    </div>
                    </div>
                    <div class="col-lg-6 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <label>App password*</label>
                          <input type="text" class="form-control" placeholder="Type here" formControlName="appPassword">
                        </div>
                        </div>
              
            </div>
      </form>

      <div class="content">
        <button class="btn-two" (click)="save()">Save</button>
    </div>


     <div class="footer-section2">

        <img src="../../assets/images/accruon-footer.png">
     </div>
    
    </div>



<!---------------->
                 
       </div>                 
                 
                    </div>
                   
            </div>

    
            </main>
   
    </div>
    </div>

</body>